import { Box, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';
import { eventsModalStyles } from './styles';
import { ICalendarEvent } from '../../../../global/interfaces';

import { format } from 'date-fns';
import dayjs from 'dayjs';
import { COLORS } from '../../../../utils/colors';
import { useBookingsContext } from '../../../../contexts/BookingsContext';
import { Close } from '@mui/icons-material';

interface EventsModalProps {
  open: boolean;
  onClose: () => void;
  events: ICalendarEvent[];
  position: { top: number; left: number };
  day: { date: string; day: string };
}

const AllEventsModal = ({
  events,
  open,
  onClose,
  position,
  day,
}: EventsModalProps) => {
  const { setSelectedBooking, setIsSessionSummaryModalOpen, getIconStyle } =
    useBookingsContext();
  const styles = eventsModalStyles();

  const handleEventClick = (event: ICalendarEvent) => {
    setSelectedBooking(event.details);
    setIsSessionSummaryModalOpen(true);
    onClose();
  };

  return (
    <>
      <Modal
        componentsProps={{
          backdrop: {
            sx: {
              backgroundColor: 'transparent',
            },
          },
        }}
        open={open}
        onClose={onClose}>
        <Box
          sx={{
            ...styles.modal,
            position: 'absolute',
            top: position?.top || '50%',
            left: position?.left || '50%',
            transform: position ? 'none' : 'translate(-50%, -50%)',
            backgroundColor: '#f6f9ff',
          }}>
          <Box sx={{ backgroundColor: '#f6f9ff' }}>
            <Box display={'block'} paddingBottom={'0.5rem'}>
              <Box
                width={'100%'}
                display={'flex'}
                justifyContent={'space-evenly'}
                alignItems={'center'}>
                <Box flex="1" />
                <Typography
                  marginRight={'1rem'}
                  flex="1"
                  color={'#575654'}
                  fontSize={'12px'}
                  fontWeight={'normal'}
                  textAlign={'center'}>
                  {day.day}
                </Typography>
                <IconButton onClick={() => onClose()}>
                  <Close fontSize="small" />
                </IconButton>
              </Box>
              <Typography
                color={'#575654'}
                fontWeight={500}
                fontSize={'1rem'}
                marginLeft={'auto'}
                textAlign={'center'}>
                {day.date}
              </Typography>
            </Box>
            <Box marginTop={'0.5rem'}>
              {events.map((calEvent: ICalendarEvent) => (
                <Box sx={styles.eventContainer}>
                  <Box sx={getIconStyle(calEvent.title)}></Box>
                  <Typography
                    color={COLORS.DARK_GREY}
                    marginRight={'0.4rem'}
                    sx={{ fontSize: '12px' }}>
                    {`${dayjs(calEvent.start).format('hh:mm A')}`}
                  </Typography>
                  <Typography
                    onClick={() => {
                      handleEventClick(calEvent);
                    }}
                    sx={{
                      fontSize: '12px',
                      fontWeight: '500',
                      cursor: 'pointer',
                    }}
                    color={COLORS.DARK_GREY}>
                    {calEvent.title}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AllEventsModal;
